export const messages = {
  en: {
    contractApplyAuditOrders: {
      draftPendingList: 'Draft Pending List',
      contractCode: 'Contract Code',
      contractName: 'Contract Name',
      contractType: 'Contract Type',
      contractStatus: 'Contract Status',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      audit: 'Audit',
      finish: 'Finish',
      processEnd: 'Process End'
    },
    flowAudit: {
      auditInfo: 'Audit Information',
      auditStatus: 'Audit Status',
      pleaseAudit: 'Please Audit',
      agree: 'Agree',
      reject: 'Reject',
      reason: 'Reason',
      requiredReason: 'Required, please fill in the reason',
      staff: 'Staff',
      selectNextHandler: 'Required, please select next handler',
      select: 'Select',
      auditStatusRequired: 'Audit status cannot be empty',
      reasonRequired: 'Reason content cannot be empty',
      reasonMaxLength: 'Reason content cannot exceed 200 characters'
    },
  },
  zh: {
    contractApplyAuditOrders: {
      draftPendingList: '起草待办单',
      contractCode: '合同编号',
      contractName: '合同名称',
      contractType: '合同类型',
      contractStatus: '合同状态',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      audit: '审批',
      finish: '结束',
      processEnd: '处理结束'
    },
flowAudit: {
      auditInfo: '审核信息',
      auditStatus: '审核状态',
      pleaseAudit: '请审核',
      agree: '同意',
      reject: '拒绝',
      reason: '原因',
      requiredReason: '必填，请填写原因',
      staff: '员工',
      selectNextHandler: '必填，请选择下一处理人',
      select: '选择',
      auditStatusRequired: '审核状态不能为空',
      reasonRequired: '原因内容不能为空',
      reasonMaxLength: '原因内容不能超过200字'
    },
  },
  'zh-TW': {
    contractApplyAuditOrders: {
      draftPendingList: '起草待辦單',
      contractCode: '合同編號',
      contractName: '合同名稱',
      contractType: '合同類型',
      contractStatus: '合同狀態',
      createTime: '創建時間',
      operation: '操作',
      view: '查看',
      audit: '審批',
      finish: '結束',
      processEnd: '處理結束'
    },
    flowAudit: {
      auditInfo: '審核信息',
      auditStatus: '審核狀態',
      pleaseAudit: '請審核',
      agree: '同意',
      reject: '拒絕',
      reason: '原因',
      requiredReason: '必填，請填寫原因',
      staff: '員工',
      selectNextHandler: '必填，請選擇下一處理人',
      select: '選擇',
      auditStatusRequired: '審核狀態不能為空',
      reasonRequired: '原因內容不能為空',
      reasonMaxLength: '原因內容不能超過200字'
    },
  }
}